import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const canvasLms = defineConnector({
  identifier: "canvasLms",
  name: "Canvas LMS",
  tagLine: "Learning management system",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ hostname }) => domainToRegex(hostname),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Canvas LMS instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Canvas LMS instance.",
        },
        {
          kind: "input",
          label: "Canvas Install URL",
          placeholder: "canvas.instructure.com",
          required: true,
          target: { kind: "configuration", field: "hostname" },
          helperText:
            "The base URL of your Canvas instance (e.g. https://canvas.instructure.com)",
        },
      ],
    },
    {
      title: "Create a Canvas LMS app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Canvas LMS OAuth docs](https://canvas.instructure.com/doc/api/file.oauth.html) and create a developer key in your Canvas admin settings. Copy the client ID and client secret, and note the Canvas hostname for your institution.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/canvasLms/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Canvas LMS account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Canvas LMS account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.hostname}/login/oauth2/auth`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.hostname}/login/oauth2/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) => `https://${configuration.hostname}/`,
  },
  publicEnvVars: ({ hostname }) => ({
    CANVAS_LMS_URL: hostname ? `https://${hostname}` : "",
  }),
});
